import { Link } from "react-router-dom";

interface CategoryEntryProps {
  movieCount: number;
  tvCount: number;
}

export default function CategoryEntry({ movieCount, tvCount }: CategoryEntryProps) {
  const entries = [
    {
      to: "/category/movie",
      icon: "ri-film-line",
      title: "电影",
      desc: "动作 · 科幻 · 剧情 · 悬疑",
      count: movieCount,
    },
    {
      to: "/category/tv",
      icon: "ri-tv-2-line",
      title: "电视剧",
      desc: "都市 · 奇幻 · 律政 · 历史",
      count: tvCount,
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {entries.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/60"
        >
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-500/15 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-950">
            <i className={`${entry.icon} text-2xl`} aria-hidden="true"></i>
          </span>
          <div className="min-w-0">
            <h3 className="font-heading text-lg font-700 text-foreground-950">{entry.title}</h3>
            <p className="truncate text-xs text-foreground-500">{entry.desc}</p>
            <p className="mt-1 text-xs font-500 text-accent-400">{entry.count} 部作品</p>
          </div>
          <i
            className="ri-arrow-right-line ml-auto text-lg text-foreground-500 transition-colors group-hover:text-primary-400"
            aria-hidden="true"
          ></i>
        </Link>
      ))}
    </div>
  );
}